import { Card, CardContent, Typography, Stack, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { EmptyList } from "../../components/EmptyList";
import { Acquirer } from "../../interfaces/acquirer";
import { IntegrationItem } from "./IntegrationItem";

interface ActiveIntegrationsProps {
    data: Acquirer[];
    isLoading: boolean;
}

export function ActiveIntegrations({
    data,
    isLoading,
}: ActiveIntegrationsProps) {
    const navigate = useNavigate();

    return (
        <Card
            variant="outlined"
            style={{ height: "100%", minHeight: 300 }}
            sx={{ borderRadius: 2 }}
        >
            <CardContent style={{ height: "100%" }}>
                <Box display="flex" justifyContent="space-between">
                    <Typography fontWeight={600}>Integrações Ativas</Typography>
                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate("/acquirer/integrations")}
                    >
                        Ver todas
                    </Typography>
                </Box>

                <Stack spacing={2} mt={2}>
                    {data?.map((item) => (
                        <IntegrationItem key={item.id} data={item} />
                    ))}
                </Stack>

                <EmptyList
                    title="Nenhuma integração ativa encontrada"
                    loading={isLoading}
                    isEmpty={data?.length === 0}
                />
            </CardContent>
        </Card>
    );
}
